import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function FeedbackList() {
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      const querySnapshot = await getDocs(collection(db, 'feedback'));
      const fb = [];
      querySnapshot.forEach(doc => fb.push(doc.data()));
      setFeedbacks(fb);
    };
    fetchFeedbacks();
  }, []);

  return (
    <div>
      <h4>Feedback</h4>
      <table border="1" cellPadding="8" style={{ width: '100%', marginTop: 10 }}>
        <thead>
          <tr>
            <th>Provider ID</th>
            <th>Rating</th>
            <th>Feedback</th>
          </tr>
        </thead>
        <tbody>
          {feedbacks.map((f, i) => (
            <tr key={i}>
              <td>{f.providerId}</td>
              <td>{f.rating}</td>
              <td>{f.feedback}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}